import styled from "@emotion/styled";

export const BackGround = styled.div`
	width: 100vw;
	min-height: 100%;
	background-color: #000000;
`;

export const Layout = styled.div`
	display: flex;
	flex-direction: row;
	min-height: 100%;
`;

export const Content = styled.div`
	flex: 1 0 auto;
	position: relative;
	min-height: 100%;
	max-width: 100%;
	min-width: 60vw;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: white;
	overflow-y: auto;
	overflow-x: hidden;

	@media screen and (max-device-height: 900px) {
		justify-content: start;
	}

	.container {
		margin: 20px auto;
		width: 90vw;
		max-width: 500px;
		border-radius: 30px;
		box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,
			rgb(145 158 171 / 12%) 0px 12px 24px 10px;
		padding: 5%;

		.description1 {
			font-style: normal;
			font-weight: 400;
			font-size: 15px;
			line-height: 17px;
			color: #111111;
			text-align: center;
		}

		.description2 {
			text-align: center;
			font-weight: 400;
			font-size: 15px;
			line-height: 17px;
			color: #111111;
			white-space: pre-wrap;
			word-break: break-all;
		}

		> .title {
			font-size: 30px;
			font-weight: 800;
			text-align: left;
			color: #111;
			text-align: center;
		}

		> .inputLabel {
			height: 20px;
			align-self: stretch;
			flex-grow: 0;
			font-family: NanumGothic;
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.43;
			letter-spacing: 0.4px;
			text-align: left;
			color: #000;
		}

		> .textFiled {
			height: 48px;
			line-height: 48px;
			align-self: stretch;
			flex-grow: 0;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 10px;
			padding: 12px;
			border-radius: 8px;
			border: solid 1px #afb1b6;
			background-color: white;
			width: 100%;
			margin-top: 8px;
			box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,
				rgb(145 158 171 / 12%) 0px 12px 24px 10px;
		}

		.link {
			font-weight: 700;
			font-size: 12px;
			line-height: 10px;
			text-decoration-line: underline;
			color: #afb1b6;
		}

		.goJoin {
			font-weight: 700;
			font-size: 16px;
			line-height: 16px;
			text-align: center;

			/* Black */

			color: #000000;
			> span {
				background: var(--primary);
				text-decoration-line: underline;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
				text-fill-color: transparent;
			}
		}
	}
`;

export const Terms = styled.div`
	margin: 0;
	line-height: 1.5714285714285714;
	font-size: 13px;
	font-weight: 400;
	text-align: center;
	color: #212b36;
	margin-top: 24px;

	> a {
		margin: 0;
		color: #212b36;
		&:hover {
			color: #0378ef;
		}
	}
`;

export const EmptySpace = styled.div<{ space: number }>`
	height: ${(props) => props.space}px;
	width: 100%;
`;
